import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FB_API_KEY,
  authDomain: import.meta.env.VITE_FB_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FB_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FB_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FB_MSG_SENDER_ID,
  appId: import.meta.env.VITE_FB_APP_ID,
};

/**
 * Mientras no exista un .env con las credenciales, la web sigue funcionando
 * contra el catalogo de demostracion (src/lib/catalogoDemo.js). En cuanto se
 * rellena el .env, los mismos hooks pasan a leer de Firestore sin tocar nada.
 */
export const firebaseListo = Boolean(
  firebaseConfig.apiKey && firebaseConfig.projectId
);

export const app = firebaseListo ? initializeApp(firebaseConfig) : null;
export const auth = firebaseListo ? getAuth(app) : null;
export const db = firebaseListo ? getFirestore(app) : null;
export const storage = firebaseListo ? getStorage(app) : null;

export const googleProvider = firebaseListo ? new GoogleAuthProvider() : null;
googleProvider?.setCustomParameters({ prompt: "select_account" });

if (!firebaseListo && import.meta.env.DEV) {
  console.info(
    "[Aceros Lima] Sin credenciales de Firebase: la web corre con el catalogo demo. " +
      "Copia .env.example a .env y rellena los valores para conectar el backend."
  );
}
